import {ErrorHandlingComponent} from '../../error-handling.component';
import {Directive, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {BankAccount} from '../../model/bank-account';

@Directive()
export abstract class BankDetailsDirective extends ErrorHandlingComponent {
    public searchBankFormGroup: FormGroup;

    @Input()
    public bankAccount: BankAccount;

    protected errorMessages(): object {
        return {
            bankName: [{
                type: 'required',
                message: 'Please select a bank'
            }, {
                type: 'invalidBankName',
                message: 'Please select valid bank'
            }],
            bankCity: [{
                type: 'required',
                message: 'Please select a city'
            }, {
                type: 'invalidBankCity',
                message: 'Please select valid city'
            }],
            bankBranchName: [{
                type: 'required',
                message: 'Please select a branch'
            }, {
                type: 'invalidBankBranch',
                message: 'Please select valid bank branch'
            }],
            ifscCode: [{
                type: 'required',
                message: 'Please provide an IFSC number'
            }, {
                type: 'pattern',
                message: 'Please enter a valid IFSC code'
            }, {
                type: 'notExist',
                message: 'The IFSC code you have entered does not exist'
            }]
        };
    }

    constructor() {
        super();
    }

}
